import axios from "axios";
import Toast from 'vue-toastification'

export default{
    name : 'Register',

    data(){
        return{
            username:'',
            email:'',
            mobile:'',
            password:'',
            cPassword:'',
            usernameError:false,
            emailError:false,
            mobileError:false,
            confirmPasswordError:false,
            alertPopup:undefined,
        }     
    },
    mounted() {
        
    },

    methods: {
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validNumber(number){
            var no=/^[0-9]{10}$/;
            return no.test(number);
        },
        submit(){
            let url= "/api/v1/Register"
            let payload={
                "username":this.username,
                "email":this.email,
                "password":this.password,
            };
            if(this.username=="")
            this.usernameError=true
            if (!this.validEmail(this.email) || !this.email) {
                this.emailError=true
            }
            if(this.password!==this.cPassword){
                this.confirmPasswordError=true
            }
            if(this.usernameError == false && this.emailError==false && this.confirmPasswordError==false)
            {
                axios.post(url,payload).then((Response) => {
                    const resData=Response.data
                    // alert(resData.summary);
                    self.username=''
                    self.email=''
                    self.password=''
                    self.cPassword =''
                    this.$toast.success('Register Successful', {
                        position: "bottom-center",
                        timeout: 5000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: true,
                        rtl: false
                    });
                }).catch((err) => {
                    
                    console.log(err,"check")
                    // console.log(payload);
                    this.$toast.error('User exists', {
                        position: "bottom-center",
                        timeout: 5000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: true,
                        rtl: false
                    });
            })
            }      
        }    
    },
}